import { HeroUIProvider, ToastProvider } from "@heroui/react";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Amplify } from "aws-amplify";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Routes from "./routes.tsx";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  integrations: [],
  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  // tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
});

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: "ap-northeast-2_mJamQF510",
      userPoolClientId: "bm19dmqvaakjmq0u016c74ujm",
      loginWith: {
        email: true,
      },
    },
  },
});

const queryClient = new QueryClient();

// biome-ignore lint/style/noNonNullAssertion:
const container = document.getElementById("root")!;
createRoot(container, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <HeroUIProvider locale="ko-KR" disableRipple>
      <QueryClientProvider client={queryClient}>
        <Routes />
      </QueryClientProvider>
      <ToastProvider />
    </HeroUIProvider>
  </StrictMode>,
);
